"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAd = createAd;
async function createAd(advertisingRepo, payload) {
    return advertisingRepo.createAd(payload);
}
